export default "<i class=\"fas fa-file-import\" (click)=\"propagateClick  == 'true' && !disabled && openDialog()\" [ngClass]=\"{'disabled': disabled}\"></i>\n"